import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Cookies from "js-cookie";
import { Toast } from "react-bootstrap";
import { all_routes } from "../../../../router/all_routes";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import DualListBox from "../../../../duallistBox";

interface Option {
  value: number;
  label: string;
}

type DualList = {
  id: number;
  name: string;
};

interface ErrorMessages {
  name?: string[];
  is_active?: string[];
}

const EditSedTeamManagement = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();

  const [isLoading, setIsLoading] = useState(false);
  const [managerName, setManagerName] = useState("");
  const [isActive, setIsActive] = useState(true);

  const [teamLead, setTeamLead] = useState<DualList[]>([]);
  const [teamMembers, setTeamMembers] = useState<DualList[]>([]);

  const [selectedTeamLead, setSelectedTeamLead] = useState<Option | null>(null);

  const [chosenTeamMembers, setChosenTeamMembers] = useState<DualList[]>([]);
  const [showToast, setShowToast] = useState(false);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    if ((showSolidDangerToast || showSolidSuccessToast) === true) {
      setTimeout(() => setShowSolidDangerToast(false), 5000);
      setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  }, [toastMessage]);

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject,
    );
  };

//  Fetch Team Lead
  const fetchTeamLead = async () => {
    const response = await fetch(
      `${webApi}sed/users_dropdown_for_sed_team_lead/`,
      options,
    );

    const data = await response.json();

    const formatted = data.map((item: any) => ({
      id: item.id,
      name: item.name,
    }));

    setTeamLead(formatted);
    return formatted;
  };

//   Fetch Team Members
  const fetchTeamMembers = async () => {
    const response = await fetch(
      `${webApi}sed/users_dropdown_for_sed_team_members/`,
      options,
    );

    const data = await response.json();

    const formatted = data.map((item: any) => ({
      id: item.id,
      name: item.name,
    }));

    setTeamMembers(formatted);
    return formatted;
  };

  const fetchSedTeam = async (allMembers: DualList[], allLeads: DualList[]) => {
    const response = await fetch(`${webApi}sed/sed_team_mgmt/${id}/`, options);
    const data = await response.json();
    setManagerName(data.name);
    setIsActive(data.is_active);
    const selectedMembers = allMembers.filter((member) =>
      data.team_members.includes(member.id),
    );
    setChosenTeamMembers(selectedMembers);
    const matchedLead = allLeads.find((lead) => lead.id === data.team_lead);
    if (matchedLead) {
      setSelectedTeamLead({
        value: matchedLead.id,
        label: matchedLead.name,
      });
    }
  };

  useEffect(() => {
    const loadData = async () => {
      if (!checkPermission("change_sedmanagers", "sedmanagers")) {
        navigate(routes.crmLandingPage);
        return;
      }

      const leads = await fetchTeamLead();
      const members = await fetchTeamMembers();
      await fetchSedTeam(members, leads);
    };

    loadData();
  }, [userPermissions]);

  const teamLeadOptions: Option[] = teamLead.map((lead) => ({
    value: lead.id,
    label: lead.name,
  }));

  const handleTeamLeadChange = (option: any) => {
    setSelectedTeamLead(option);
  };

  const handleTeamMembersChange = (selected: DualList[]) => {
    setChosenTeamMembers(selected);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload = {
      name: managerName,
      team_lead: selectedTeamLead?.value,
      team_members: chosenTeamMembers.map((member) => member.id),
      is_active: isActive,
    };

    try {
      setIsLoading(true);

      const response = await fetch(`${webApi}sed/sed_team_mgmt/${id}/`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData);
        setToastMessage(errorData.name);
        if (toastMessage !== "") {
          setShowSolidDangerToast(true);
        }
        throw new Error("Network response was not ok");
      }
      navigate(routes.SEDTeamManagement);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Edit Teams</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDDashBoard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDTeamManagement}>Team Management</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add manager */}
              <div
                className="card w-100"
                style={{
                  maxWidth: "900px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 mb-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label">Team Name</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errorMessage.name ? "is-invalid" : ""
                          }`}
                          name="name"
                          placeholder="Team Name"
                          onChange={(e) => {
                            setManagerName(e.target.value);
                          }}
                          value={managerName}
                          required
                        />
                        {errorMessage.name && (
                          <div className="invalid-feedback">
                            {errorMessage.name[0]}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <div className="radio-group mb-3">
                          <label className="form-label">Is Active</label>

                          <div className="d-flex gap-4 mt-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="isActive"
                                id="activeYes"
                                checked={isActive === true}
                                onChange={() => setIsActive(true)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="activeYes"
                              >
                                Active
                              </label>
                            </div>

                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="isActive"
                                id="activeNo"
                                checked={isActive === false}
                                onChange={() => setIsActive(false)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="activeNo"
                              >
                                Inactive
                              </label>
                            </div>
                          </div>
                          {errorMessage.is_active && (
                            <div className="text-danger mt-1">
                              {errorMessage.is_active[0]}
                            </div>
                          )}
                        </div>
                      </div>
                      <div style={{ width: "28%" }}>
                        <label className="form-label">Team Lead</label>
                        <Select
                          value={selectedTeamLead}
                          onChange={handleTeamLeadChange}
                          options={teamLeadOptions}
                          placeholder="Select a Team Lead"
                          required
                        />
                      </div>
                    </div>

                    <div className="form-group dual-list-box-container">
                      <label className="form-label">Team Members</label>
                      <DualListBox
                        options={teamMembers}
                        selected={chosenTeamMembers}
                        onChange={handleTeamMembersChange}
                      />
                    </div>
                    {/* <div className="form-group dual-list-box-container">
                      <label className="form-label">Team Members</label>
                      <DualListBox
                        options={teamMembers}
                        selected={chosenTeamMembers}
                        onChange={handleTeamMembersChange}
                      />
                    </div> */}
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.SEDTeamManagement}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default EditSedTeamManagement;
